// @ts-nocheck
/* eslint-disable */
export const checkLineIcon = {
  data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.33309 12.6425L15.9934 4.98218L17.1719 6.16069L8.33309 14.9995L3.02979 9.69624L4.2083 8.51774L8.33309 12.6425Z" fill="currentColor"/></svg>`,
  name: 'check-line' as const,
};
